import { useGetInvoiceConfig } from "api/queries/invoice/useGetInvoiceConfig";
import React, { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetShipmentInvoices } from "api/queries/invoice/useGetShipmentInvoices";
import InvoiceFormBucketAttachmentItem from "./InvoiceFormBucketAttachmentItem";

function InvoiceFormBucketAttachments({ missingAttachmentBuckets }: { missingAttachmentBuckets: string[] }) {
  const { id: shipmentId } = useParams();
  const [searchParams] = useSearchParams();
  const currentInvoiceId = searchParams.get("invoice");

  const { data: invoiceConfig }: any = useGetInvoiceConfig({
    shipmentId: shipmentId!,
    currentInvoiceId: currentInvoiceId!,
    options: { refetchOnMount: false },
  });

  const bucketAttachments = useMemo(
    () =>
      invoiceConfig?.invoice_attachment_bucket?.filter((item: any) => item?.bucket_name?.toLowerCase?.() !== "other") || [],
    [invoiceConfig],
  );

  const { data: invoices }: any = useGetShipmentInvoices({
    shipmentId: shipmentId!,
    options: {
      select: (data: any) => data.results,
      refetchOnMount: false,
    },
  });

  const currentInvoice = useMemo(
    () => invoices?.find((invoice: any) => invoice.invoice_id === currentInvoiceId),
    [currentInvoiceId, invoices],
  );

  const isIntermediateInvoice = currentInvoice?.invoice_type === "intermediate_invoice";
  const isCustomsInvoice = currentInvoice?.invoice_type === "customs_broker_invoice";

  return (
    !!bucketAttachments?.length &&
    bucketAttachments.map((bucket: any) => (
      <InvoiceFormBucketAttachmentItem
        isCustomsInvoice={isCustomsInvoice}
        isIntermediateInvoice={isIntermediateInvoice}
        key={currentInvoiceId + bucket.id}
        bucket={bucket}
        missingAttachmentBuckets={missingAttachmentBuckets}
        stopAssociationEnabled={!!invoiceConfig?.stop_association_enabled}
        shipmentStops={invoiceConfig?.shipment_stops || []}
      />
    ))
  );
}

export default InvoiceFormBucketAttachments;
